const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export interface SchoolLessonIdentity {
  sessionId: string;
  pupilId: string;
}

export function isSchoolLessonUuid(value: string): boolean {
  return UUID.test(value);
}

export function schoolLessonIdentityFromBookingId(bookingId: string): SchoolLessonIdentity | null {
  const parts = bookingId.split(":");
  if (parts.length !== 3 || parts[0] !== "school") return null;
  const sessionId = parts[1] ?? "";
  const pupilId = parts[2] ?? "";
  if (!isSchoolLessonUuid(sessionId) || !isSchoolLessonUuid(pupilId)) return null;
  return { sessionId, pupilId };
}

export function schoolLessonWriteupHref(bookingId: string): string | null {
  const identity = schoolLessonIdentityFromBookingId(bookingId);
  if (!identity) return null;
  const params = new URLSearchParams({
    writeup: "1",
    session: identity.sessionId,
    pupil: identity.pupilId,
  });
  return `/schools?${params.toString()}`;
}
